export default __webpack_public_path__ + "static/media/cert-general-staff-a-cpttm.417716fa.jpg";